import { render } from "./CiientButton.vue?vue&type=template&id=731b94fb"
import script from "./CiientButton.vue?vue&type=script&lang=js"
export * from "./CiientButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__